/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface JiraStatusInfo
 */
export interface JiraStatusInfo {
    /**
     * 
     * @type {string}
     * @memberof JiraStatusInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JiraStatusInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JiraStatusInfo
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof JiraStatusInfo
     */
    statusCategory?: string;
}

export function JiraStatusInfoFromJSON(json: any): JiraStatusInfo {
    return {
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'statusCategory': !exists(json, 'statusCategory') ? undefined : json['statusCategory'],
    };
}

export function JiraStatusInfoToJSON(value?: JiraStatusInfo): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'statusCategory': value.statusCategory,
    };
}


